var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dataContent"},[_c('div',{staticClass:"dataTitle"},[_vm._v("料肉比（FCR）分析"),_c('span',{staticClass:"dataTitleTips"},[_vm._v("（基于饲料BU全部数据实时生成）")])]),_c('div',[_c('div',{attrs:{"id":"graph"}}),_c('div',{staticClass:"svgcontainer",attrs:{"id":"svgcontainer"}})])])
}]

export { render, staticRenderFns }